<template>
    <div class="curriculumPublic flex-align-center">
        <div class="curriculumPublic_box ">
            <div class="school-sort flex-align-between">
                <ul class="flex-layout sort-ul">
                    <li v-for="(item, index) in sortList" :key="index" :class="{ 'active': activeSortId === item.id }"
                        class="csp" @click="changeSort(item, index)">
                        {{ item.name }}
                    </li>
                </ul>
                <div class="search">
                    <el-input @input="filterCourse()" v-model="sortSearch" size="medium" placeholder="请输入课程名称"
                        style="width: 156px;" suffix-icon="el-icon-search"></el-input>
                </div>
            </div>
            <div class="school-list" v-if="courseList.length != 0">
                <ul class="flex-align school-list-ul">
                    <li v-for="(item, index) in courseList" :key="index" @click="toDeatil(item, index)">
                        <div class="card">
                            <img class="course-type-image"
                                :src="item.lessonsPattern === 0 ? require('@/assets/images/course/syncourse.png') : item.lessonsPattern === 1 ? require('@/assets/images/course/asyncourse.png') : require('@/assets/images/course/opendourse.png')"
                                alt="" />
                            <img class="cardImg" :src="downloadURL + item.cover"
                                :onerror="$store.state.course.defaultCourseCover[index % 5]" alt />

                        </div>
                        <div class="particulars">
                            <h3 class="title wes-2">
                                {{ item.name || item.themeName }}
                            </h3>
                            <div class="teach">主讲老师：{{ item.teacherName }}</div>
                            <div class="date">上课时间：{{ item.timeScope }}</div>
                        </div>
                    </li>
                </ul>
                <div class="paginationBox">
                    <pagination2 :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                        :pageSizes="[8, 16, 24]" @pagination="handlePageChange">
                    </pagination2>
                </div>
            </div>
            <div class="school_empty flex-align-center" v-else>
                <el-empty description="暂无课程"></el-empty>
            </div>
        </div>
        <Login3 v-if="showLogin" @getUserinfo="getUserinfo"></Login3>
    </div>
</template>

<script>
import pagination2 from '../components/common/pagination2.vue'
export default {
    //import引入组件才能使用
    components: {
        pagination2
    },
    props: {},
    data() {
        return {
            activeSortId: 0,
            sortSearch: '',
            sortList: [
                {
                    id: 0,
                    name: '最热'
                },
                {
                    id: 1,
                    name: '推荐'
                },
            ],
            courseList: [],
            pages: { //分页
                currentPage: 1,
                pageSize: 8,
                total: 0,
            },
            markClass: {
                '2': '同步课堂',
                '3': '同步教研',
                '4': '优质课程',
            },
            showLogin:false
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 切换排序类型(热门-推荐)
        changeSort(item, index) {
            this.activeSortId = item.id;
            this.getCourselist();
        },
        //输入框搜索
        filterCourse(val) {
            console.log(val);
            this.getCourselist();
        },
        toDeatil(item, index) {
            if (!sessionStorage.getItem('token')) {
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
            }else{
                this.$router.push({
                path: `/home/curriculumPublic/detail/${item.id}`,
                query: {
                    'id': item.id,
                    'index': index,
                    'videoType': this.$route.query.markType,
                    'breadNumber': 3,
                    //同步教研
                }
            });
            }

            // this.$store.commit('breadPageNameChange', item.name)
        },
        //分页操作
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.getCourselist();
        },
        //课程列表请求
        async getCourselist() {
            let data = {
                markId: this.$route.query.markType,
                page: this.pages.currentPage,
                limit: this.pages.pageSize,
                orderType: this.activeSortId,
                name: this.sortSearch
            }
            let resData = await Api.Curriculum.getCourselist(data);
            this.pages.total = resData.data.total;
            this.courseList = resData.data.records;
            this.changeBreadName()
        },
        changeBreadName() {
            // console.log('111', this.markClass[this.$route.query.markType]);
            // console.log('跳转课程labelList', this.$store.state.basics.breadList);
            this.$store.commit('breadPageNameChange', this.markClass[this.$route.query.markType])
            // console.log('修改后labelList', this.$store.state.basics.breadList);

        }
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getCourselist();

    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style lang="less" scoped>
@import'./less/curriculumPublic.less';
</style>